// Datasources

import type {
  UsersSyncIntegrationSpec,
  UsersSyncIntegrationStruct,
} from '@cohort/shared/schema/apps/app';
import {UserPropertyDataTypeSchema} from '@cohort/shared/schema/common/userProperty';
import {z} from 'zod';

// Custom Query
export const PostsgresqlUserPropertyColumnSchema = z.object({
  columnName: z.string(),
  referenceId: z.string(),
  propertyName: z.string(),
  dataType: UserPropertyDataTypeSchema,
});
export type PostsgresqlUserPropertyColumn = z.infer<typeof PostsgresqlUserPropertyColumnSchema>;

export const PostgresqlUsersSyncConfigSchema = z.object({
  query: z.string(),
  userPropertyColumns: z.array(PostsgresqlUserPropertyColumnSchema),
  emailColumn: z.string(),
});

export type PostgresqlUsersSyncConfig = z.infer<typeof PostgresqlUsersSyncConfigSchema>;

export type PostgresqlUsersSyncStruct = UsersSyncIntegrationStruct<PostgresqlUsersSyncConfig>;

export const PostgresqlUsersSyncIntegrationSpec: UsersSyncIntegrationSpec<PostgresqlUsersSyncStruct> =
  {
    id: 'postgresql.users-sync',
    configSchema: PostgresqlUsersSyncConfigSchema,
  };
